const getFormDataAsJson = require("../form/getFormDataAsJson");
const convertPreferenceCenterFormDataToMarketoFormData = require("./convertPreferenceCenterFormDataToMarketoFormData");
const validateEmail = require("../validation/validateEmail");
const showPreferenceCenterFormEmailError = require("./showPreferenceCenterFormEmailError");
const loadMarketoForm = require("../marketo/loadMarketoForm");
const submitMarketoForm = require("../marketo/submitMarketoForm");
const copyFormDataIntoMarketoForm = require("../marketo/copyFormDataIntoMarketoForm");
const removeMarketoFormEmbed = require("../marketo/removeMarketoFormEmbed");
const disableSubmitButtonInForm = require("../form/disableSubmitButtonInForm");
const enableSubmitButtonInForm = require("../form/enableSubmitButtonInForm");
const showLoadingDialog = require("../loadingDialog/showLoadingDialog");
const showSuccessDialogToast = require("../successDialog/showSuccessDialogToast");
const hideLoadingDialog = require("../loadingDialog/hideLoadingDialog");
const showPreferenceCenterFormPhoneNumberError = require("./showPreferenceCenterFormPhoneNumberError");
const validatePreferenceCenterPhoneNumber = require("./validatePreferenceCenterPhoneNumber");
const submitPreferenceCenterUpdateUser = require("./submitPreferenceCenterUpdateUser");
const PreferenceCenter_validatePrivacyPolicy = require("./PreferenceCenter_validatePrivacyPolicy");
const PreferenceCenter_showPrivacyPolicyError = require("./PreferenceCenter_showPrivacyPolicyError");

/**
 * @param preferenceCenterForm {HTMLFormElement}
 * @return {void}
 */
module.exports = async function whenPreferenceCenterFormSubmit(preferenceCenterForm) {
    disableSubmitButtonInForm(preferenceCenterForm);

    const preferenceCenterFormData = getFormDataAsJson(preferenceCenterForm);

    const emailError = validateEmail(preferenceCenterFormData["email"]);

    if (emailError) {
        showPreferenceCenterFormEmailError(preferenceCenterForm, emailError);
    }

    const phoneNumberError = validatePreferenceCenterPhoneNumber(preferenceCenterFormData["phoneNumber"], preferenceCenterFormData["marketingSMSOptIn"]);
    if (phoneNumberError) {
        showPreferenceCenterFormPhoneNumberError(preferenceCenterForm, phoneNumberError);
    }

    let privacyPolicyError = PreferenceCenter_validatePrivacyPolicy(preferenceCenterForm);
    if (privacyPolicyError) {
        PreferenceCenter_showPrivacyPolicyError(preferenceCenterForm);
    }

    if (emailError || phoneNumberError || privacyPolicyError) {
        enableSubmitButtonInForm(preferenceCenterForm);
        return;
    }

    const loadingDialog$ = showLoadingDialog();

    try {
        const {marketoForm, marketoFormContainer} = await loadMarketoForm("1275");

        const preferenceCenterMarketoFormData = convertPreferenceCenterFormDataToMarketoFormData(preferenceCenterFormData);
        copyFormDataIntoMarketoForm(marketoForm, preferenceCenterMarketoFormData);

        await Promise.all([
            submitMarketoForm(marketoForm),
            submitPreferenceCenterUpdateUser(preferenceCenterFormData)
        ]);

        removeMarketoFormEmbed(marketoFormContainer);

        showSuccessDialogToast("Notification settings updated");
    } catch (e) {
        console.error(e);
        alert("Something went wrong! We could not submit the form!");
    } finally {
        hideLoadingDialog(loadingDialog$);
        enableSubmitButtonInForm(preferenceCenterForm);
    }
}
